import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { PartnerProductPriceBulkUpload } from '../../models/partnerBulk';
import { getPriceUploadHistories } from '../../apis/partnerBulk';
import { isValidPositiveNumber } from './priceUploadQueryUtils';

export const usePriceUploadHistories = (
  partnerId: number,
  {
    pageNo,
  }: {
    pageNo: number;
  }
) => {
  const pageSize = 50;

  const queryOptions: UseQueryOptions<
    PageResponse<PartnerProductPriceBulkUpload>,
    Error
  > = {
    queryKey: ['priceUploadHistories', partnerId, pageNo, pageSize],
    enabled: isValidPositiveNumber(partnerId) && isValidPositiveNumber(pageNo),
    queryFn: () => {
      return getPriceUploadHistories(partnerId, {
        pageNo: pageNo,
        pageSize,
      });
    },
  };
  return useQuery(queryOptions);
};
